



























































































































































































import Vue from "vue";
import Component from "vue-class-component";

import {
  compareWithKeys,
  formatPostalCode,
  fullWidthNumConvert,
  isPostalCode,
  formatImageUrl,
} from "@/common/utils";
import QNotify from "@/common/qNotify";
import QErrors from "@/common/qErrors.vue";
import postalCode from "@/components/common/postalCode.vue";
import YubinBangoCore from "@/common/scripts/yubinbango-core";
import { GroupManagerService } from "@/common/api/services/GroupManagerService";
import uploadSingleImage from "@/components/common/uploadSingleImage.vue";
import { namespace } from "vuex-class";

const auth = namespace("Auth");

@Component({
  name: "InfoIndex",
  components: {
    QErrors,
    postalCode,
    uploadSingleImage,
  },
})
export default class InfoIndex extends Vue {
  @auth.Getter
  getUsingGroup!: string;

  public groupId = null;
  public groupImageSize = "500x158";
  public group: any = {
    id: 0,
    name: "",
    status: "",
    spokes_name: "",
    spokes_email: "",
    contact_type: "",
    image: {
      id: "",
      name: "",
    },
    description: "",
    postcode: "",
    address1: "",
    address2: "",
    phone_number: "",
    note: "",
  };
  public initData = {};
  public uploading = false;
  public file = [];

  public errors: any = {};
  public errorStyle = {
    maxWidth: "100%",
  };

  public uploadOptions = {
    maxFilesize: 5, // 5mb
    acceptedFiles: ".jpg,.png,.jpeg",
  };

  async mounted() {
    this.groupId = this.getUsingGroup;
    await this.findGroup();
    this.initData = { ...this.group };
  }

  public async findGroup() {
    const response = await GroupManagerService.groupAdminGroupInfoShow({
      id: this.groupId,
    });

    if (response.status == "error") {
      QNotify.error({
        text: response.message,
      });
      return;
    }

    this.group = response.data.group;
  }

  public async submit() {
    this.errors = {};

    let result;
    try {
      result = await GroupManagerService.groupAdminGroupInfoEdit({
        id: this.group.id,
        imageId: Number.parseInt(this.group.image?.id),
        description: this.group.description,
        postcode: this.group.postcode,
        address1: this.group.address1,
        address2: this.group.address2,
        phoneNumber: this.group.phone_number,
        note: this.group.note,
      });
    } catch (error) {
      result = error;
    }
    if (result.status == "success") {
      QNotify.success({
        text: this.$t("common.message.updated"),
      });
      this.initData = { ...this.group };
    } else if (result.status == "400") {
      this.errors = result.body.errors;
    } else {
      QNotify.error({
        text: result.body.message,
      });
    }
  }

  public cancel() {
    this.$modal.showCancel({
      text: `${this.$t("common.modal.cancel_content")}`,
      confirmText: `${this.$t("common.buttons.yes")}`,
      cancelText: `${this.$t("common.buttons.no")}`,
      onConfirm: () => {
        this.group = { ...this.initData };
        this.errors = {};
        (this.$refs.uploadSingleImage as uploadSingleImage).reset();
      },
    });
  }

  public isChanged() {
    return compareWithKeys(this.group, this.initData, [
      "name",
      "spokes_name",
      "spokes_email",
      "request_approved",
      "status",
    ]);
  }

  public findAddress(postalCode) {
    postalCode = fullWidthNumConvert(postalCode.replace("ー", ""));

    if (!isPostalCode(postalCode)) {
      this.group.address1 = "";
      return;
    }

    postalCode = formatPostalCode(postalCode);

    this.group.postcode = postalCode;
    try {
      new YubinBangoCore(
        postalCode,
        function (addr) {
          if (addr.region) {
            this.group.address1 = addr.region + addr.locality + addr.street;
          } else {
            this.group.address1 = "";
          }
        }.bind(this)
      );
    } catch (error) {
      console.error(error);
    }
  }

  public changeFile(file) {
    if (!this.group.image) {
      this.group.image = { id: 0 };
    }
    this.group.image.id = file ? file.id : null;
  }

  public changeInput(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }
  public uploadStatus(flag) {
    this.uploading = flag;
  }
  public formatImageUrl(image) {
    return image ? formatImageUrl(image, this.groupImageSize) : "";
  }
}
